import styled from 'styled-components';
import { ToggleButton as MuiToggleButton } from '@mui/material';
import CircularProgress from '../circular-progress/CircularProgress';

interface Props {
  value: boolean;
  onChange: (event: React.MouseEvent<HTMLElement>, value: boolean) => void;
  children?: React.ReactNode;
  loading?: boolean;
}

const ToggleButton = (props: Props) => {
  const { onChange, value, children, loading } = props;

  return (
    <StyledToggleButton value="check" selected={value} onChange={(e, value) => !loading && onChange(e, value)}>
      {loading ? <CircularProgress size="18px" /> : children}
    </StyledToggleButton>
  );
};

const StyledToggleButton = styled(MuiToggleButton)`
  border: none !important;
  background-color: white !important;
  height: 50px;
  width: 50px;

  :hover {
    background-color: ${(props) => props.theme.palette.grey.black10} !important;
  }
`;

export default ToggleButton;
